import {
  type FlowGetNotableObjectBlock,
  FlowGetNotableObjectConfigSchema,
  FlowNotableObject,
} from 'flow-schema';

import { GetNotableObjectFormFields } from './FormFields';
import { PatientUploadOutputContent } from './OutputContent';
import { GetNotableObjectDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

export const getNotableObjectConfig: BlockConfigProps<FlowGetNotableObjectBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'GetNotableObject',
  defaultConfig: {
    notableObject: FlowNotableObject.ReferenceTable,
    referenceTableId: '',
  },
  configFields: {
    schema: FlowGetNotableObjectConfigSchema,
    FormFields: GetNotableObjectFormFields,
  },
  documentationMarkdown: GetNotableObjectDocumentation,
  OutputContentComponent: PatientUploadOutputContent,
};
